/**
 * @generated SignedSource<<6cbf2115342aaa32b28f65f1ee4e2cfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AvatarField_User$data = {
  readonly avatarUrl: string | null | undefined;
  readonly " $fragmentType": "AvatarField_User";
};
export type AvatarField_User$key = {
  readonly " $data"?: AvatarField_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"AvatarField_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AvatarField_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "65fbfc25aa817aa08e222585df5cc976";

export default node;
